// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dnHHklFJs6Ux3cOwQkVO{justify-content:space-between;align-items:center;margin-bottom:12px;display:flex}.BipiwKDCGSIaF2VvCTN5{width:100%;height:auto}.B5LxRyOktGgPBNQDYPUn{padding:6px 0 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `dnHHklFJs6Ux3cOwQkVO`,
	"image": `BipiwKDCGSIaF2VvCTN5`,
	"tabs": `B5LxRyOktGgPBNQDYPUn`
};
export default ___CSS_LOADER_EXPORT___;
